<template>
	<div class="p-2">
		<b-row>
			<b-col md="3">
				<span class="font-weight-bold">{{ label }}</span>
			</b-col>
			<b-col md="9">
				<a v-if="link" :href="link" target="_blank">{{ text }}</a>
				<span v-else>{{ text }}</span>
			</b-col>
		</b-row>
	</div>
</template>

<script>
export default {

	props: {
		label: {
			type: String,
			required: true,
		},
		text: {
			type: String,
			required: true,
		},
		link: {
			type: Boolean,
			required: false,
			default: false,
		},
	}
}
</script>